import FaqBlock from './FaqBlock';
import container from './FaqBlock.container';
export default container(FaqBlock);
